import { ReactElement } from 'react'
import { PopoverPanel } from '@ui2/structure'
import IFCOtherTypesFilter from './IFCOtherTypesFilter'

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
}

/**
 * Filter popover for the IFC storey controls (opened from the header filter icon). Houses the
 * "Weitere Typen" multi-select for toggling the remaining IFC element types (Stützen, Träger, …).
 */
const IFCFilterPopover = ({ anchorEl, onClose }: Props): ReactElement => (
  <PopoverPanel anchorEl={anchorEl} onClose={onClose} title="Filter" dataCy="ifc-filter-popover">
    <IFCOtherTypesFilter />
  </PopoverPanel>
)

export default IFCFilterPopover
